import React, { Component } from 'react';
import { Translate } from 'react-localize-redux';
import { Link } from 'react-router-dom';

import GlobalLayout from 'Layouts/Global.layout';

import {
  handleOTPTimerOutput,
  genericComponentTimer
} from 'Utils/Helpers/component.helpers';
import { Container, Card, Text, Button, FormElements } from 'UILib';

import {
  REQUEST_STATUS,
  APP_ROUTES
} from 'Constants/GlobalConstants/Global.constants';

import 'Components/Authentication/authentication.style.scss';

const ENTER_KEY = 13;

class VerifyCodeOTP extends Component {
  constructor(props) {
    super(props);

    this.state = { otp_code: '', remaining: 60, hasDigitError: false };
  }

  componentDidMount() {
    this.timer = genericComponentTimer(() => {
      this.setState({ remaining: this.state.remaining - 1 });
    });
    document.addEventListener('keydown', (e) => {
      this.handleKeyDown(e);
    });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    document.removeEventListener('keydown', (e) => {
      this.handleKeyDown(e);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    /**
     * Resets otp_code value when a wrong otp code is entered
     */
    if (
      this.props.resetPassword.otp_code_tries !==
      prevProps.resetPassword.otp_code_tries
    ) {
      this.setState({ otp_code: '' });
    }
    /**
     * When the remaining is 0, component should move to failure escape
     */
    if (this.state.remaining === 0) {
      this.props.resetPasswordFlowVerifyCodeOTPFailure();
    }
  }

  handleKeyDown = (e) => {
    e.keyCode === ENTER_KEY && this.handleContinue();
  };

  handleChange = (otp_code) => {
    this.setState({ otp_code });
  };

  handleContinue = () => {
    const { email, action_token } = this.props.resetPassword;
    const { otp_code } = this.state;
    if (otp_code.length === 6) {
      this.setState({ hasDigitError: false });
      this.props.resetPasswordFlowVerifyCodeOTP(email, action_token, otp_code);
    } else {
      this.setState({ hasDigitError: true });
    }
  };

  render() {
    const { minutes, seconds } = handleOTPTimerOutput(this.state.remaining);
    const { otp_code } = this.state;
    const { otp_code_tries } = this.props.resetPassword;
    return (
      <Container type="page" bgColor="grey-0">
        <GlobalLayout>
          <Card type="auth" centered className="custom-form-zone">
            <Text
              type="h1"
              content="resetPassword.verify_code_otp.header"
              translation
              className="verify-code-otp-header"
            />
            <Text
              type="intro"
              content="resetPassword.verify_code_otp.description"
              className="verify-code-otp-description"
              translation
            />
            <Text
              type="h1"
              content={`${minutes}:${seconds}`}
              className="timer"
            />
            <Container className="verify-code-otp-container">
              <Container className="digits-container">
                <FormElements.Digit
                  type="number"
                  digits={6}
                  error={this.state.hasDigitError}
                  value={otp_code}
                  onChange={this.handleChange}
                />
                <Text
                  type="intro"
                  content={`${otp_code_tries} / 3`}
                  color="grey-2"
                  className="tries-text"
                />
              </Container>
              <Container className="generic-container">
                {this.props.resetPassword.error && (
                  <FormElements.ValidationErrors
                    content={`status_codes.client_codes.${
                      this.props.resetPassword.error.client_code
                    }`}
                    translation
                  />
                )}
              </Container>
              <Container className="right-align">
                <Button
                  content={
                    this.props.resetPassword.status === REQUEST_STATUS.PENDING
                      ? 'resetPassword.verify_code_otp.loading'
                      : 'resetPassword.verify_code_otp.continue_cta'
                  }
                  translation
                  className={
                    !this.props.resetPassword.error &&
                    'verify-code-otp-action-margin'
                  }
                  color="white"
                  bgColor="orange-3"
                  borderColor="orange-3"
                  onClick={() => {
                    this.handleContinue();
                  }}
                />
              </Container>
            </Container>
            <Text type="intro" className="bottom-section">
              <Translate id="resetPassword.start.footer.content" />{' '}
              <Link to={APP_ROUTES.LOGIN}>
                <Translate id="resetPassword.start.footer.cta" />
              </Link>
            </Text>
          </Card>
        </GlobalLayout>
      </Container>
    );
  }
}

export default VerifyCodeOTP;
